import './messageContainer.scss';

import PropTypes from 'prop-types';
import { Message, PartnerMessage } from '@bwoty-web/ui-kit';

const MessageContainer = ({
  isHotelOnly = false,
  labels = null,
  message = null,
  style = null,
  upsellMessage = null,
  user = '-1',
}) => {
  const messages = [];

  if (message && (message.title || message.message)) {
    if (message.severity?.toUpperCase() === 'ERROR') {
      messages.push(
        <Message
          expandable
          header={message.title}
          initiallyExpanded
          key={1}
          messageType="error"
        >
          {message.message}
        </Message>,
      );
    } else if (message.severity?.toUpperCase() === 'WARNING') {
      messages.push(
        <Message
          expandable
          header={message.title}
          initiallyExpanded
          key={1}
          messageType="alert"
        >
          {message.message}
        </Message>,
      );
    } else if (message.severity?.toUpperCase() === 'INFORMATION') {
      messages.push(
        <Message
          expandable
          header={message.title}
          initiallyExpanded
          key={1}
          messageType="info"
        >
          {message.message}
        </Message>,
      );
    }
  }

  if (user.toUpperCase() === 'Z11' && !isHotelOnly) {
    messages.push(
      <PartnerMessage
        header={labels.icaBanner}
        partner="ica"
        key={0}
      />,
    );
  }

  if (user.toUpperCase() === 'Z40' && !isHotelOnly) {
    messages.push(
      <PartnerMessage
        header={labels.plussaBanner}
        partner="plussa"
        key={0}
      />,
    );
  }

  if (upsellMessage && (upsellMessage.title || upsellMessage.message)) {
    messages.push(
      <Message
        header={upsellMessage.title}
        messageType="info"
        initiallyExpanded
        key={2}
      >
        {upsellMessage.message}
      </Message>,
    );
  }

  if (messages.length === 0) {
    return null;
  }

  return (
    <div
      className="iw-message-container"
      style={style}
    >
      {messages}
    </div>
  );
};

MessageContainer.propTypes = {
  isHotelOnly: PropTypes.bool,
  labels: PropTypes.shape({
    plussaBanner: PropTypes.string,
    icaBanner: PropTypes.string,
  }),
  message: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    severity: PropTypes.string,
  }),
  style: PropTypes.shape(),
  upsellMessage: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
  }),
  user: PropTypes.string,
};

export default MessageContainer;
